import { useAtomValue } from 'jotai';
import _ from 'lodash';
import { useRecoilValue, useRecoilValueLoadable } from 'recoil';
import {
  getHeatmapLinearRangeBucketByValue,
  HEATMAP_BUCKETS_COUNT,
} from '../../common/heatmap.helper';
import useGetNamedColor from '../../common/useGetNamedColor';
import {
  actualityAggregatedStatsBuckets,
  actualityAggregatedStatsMaxMetricValue,
  actualityAggregatedStatsMinMetricValue,
  actualityAggregatedStatsSelectedAggregatedMetric,
} from '../store/actuality.kpi.state';
import {
  ActualityAggregatedHqExtendedDataRow,
  ActualityAggregationColorBy,
  ActualityAggregationField,
} from '../store/actuality.kpi.types';
import { actualityAggregatedStatsColorBySelected } from '../store/actuality.kpi.ui.state';
import useGetActualityAggregationGroupTitle from './useGetActualityAggregationGroupTitle';

function useGetActualityAggregationGroupColors() {
  const metric = useRecoilValue(
    actualityAggregatedStatsSelectedAggregatedMetric,
  );
  const colorBy = useAtomValue(actualityAggregatedStatsColorBySelected);
  const minValue = useRecoilValue(actualityAggregatedStatsMinMetricValue);
  const maxValue = useRecoilValue(actualityAggregatedStatsMaxMetricValue);
  const bucketsLoadable = useRecoilValueLoadable(
    actualityAggregatedStatsBuckets,
  );
  const getNamedColor = useGetNamedColor();
  const getGroupTitle = useGetActualityAggregationGroupTitle();

  const buckets =
    bucketsLoadable.state === 'hasValue' ? bucketsLoadable.contents : [];
  const hasBuckets = !_.isEmpty(buckets);
  const bucketsMap = _.keyBy(buckets, 'id');

  return (
    row: ActualityAggregatedHqExtendedDataRow,
    groupFields?: ActualityAggregationField[],
    supportedColorBy?: ActualityAggregationColorBy[],
  ): [string, string] => {
    const title = getGroupTitle(row, groupFields);
    const value = row[metric] as number;
    if (
      colorBy === 'bucket' &&
      hasBuckets &&
      (_.isEmpty(supportedColorBy) || _.includes(supportedColorBy, 'bucket'))
    ) {
      const bucket = getHeatmapLinearRangeBucketByValue({
        value,
        minValue,
        maxValue,
        bucketCount: HEATMAP_BUCKETS_COUNT,
        buckets: bucketsMap,
      });
      return [bucket?.color, bucket?.textColor];
    }

    //default;
    return getNamedColor(title);
  };
}

export default useGetActualityAggregationGroupColors;
